module.exports = __webpack_public_path__ + "assets/i18n/de.json";


//////////////////
// WEBPACK FOOTER
// ./src/i18n/de.json
// module id = 1207
// module chunks = 0